import { CustomerResource } from '@/api/serverApi'
import InviteTeamMemberModal from '@/components/modals/team-members/InviteTeamMemberModal'
import { Button, SearchIcon, TextInput } from '@cfs-fixings/shared'
import { useState } from 'react'

const textSpec = {
  searchPlaceholder: 'Search members',
  inviteButtonLabel: 'Invite Users',
}

type PropTypes = {
  customer: CustomerResource
  onSearchChange?: (searchTerm: string) => void
}

function FilterTeamMembersForm ({ customer, onSearchChange }: PropTypes) {
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false)

  return (
    <>
      <div className="grid grid-cols-3 w-full">
        <div className="col-span-2 w-full">
          <TextInput
            prefixIcon={
              <SearchIcon className="w-[16px] h-[16px] text-gray-600" />
            }
            placeholder={textSpec.searchPlaceholder}
            onChange={(e) => onSearchChange?.(e.target.value)}
          />
        </div>
        <div className="flex justify-end">
          <Button
            variant={'dark'}
            onClick={() => setIsInviteModalOpen(true)}
          >
            {textSpec.inviteButtonLabel}
          </Button>
        </div>
      </div>
      <InviteTeamMemberModal
        customer={customer}
        isOpen={isInviteModalOpen}
        onClose={() => setIsInviteModalOpen(false)}
      />
    </>
  )
}

export default FilterTeamMembersForm
